import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnTextField, columnCNPJCPFField } from "utils/tables-utils";
import LoadingData from "components/Loading/LoadingData";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function TableAcompanhamentoAtendimento({
  data,
  loading,
  onRowClick,
}) {
  const columnModel = [
    columnTextField({
      dataField: "Protocolo",
      text: "Protocolo",
      align: "center",
    }),
    columnTextField({
      dataField: "ResolucaoFormat",
      text: "Status",
      align: "center",
    }),
    columnCNPJCPFField({
      dataField: "Documento",
      text: "CPF/CNPJ",
      align: "center",
    }),
    columnTextField({
      dataField: "Consumidor",
      text: "Consumidor",
      align: "center",
    }),
    columnTextField({
      dataField: "DataCriacaoFormat",
      text: "Data Criação",
      align: "center",
    }),
    columnTextField({
      dataField: "DataIntegracaoFormat",
      text: "Última Interação",
      align: "center",
    }),
    columnTextField({
      dataField: "Informations",
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <InfoOutlinedIcon
            onClick={() => {
              onRowClick(row);
            }}
            style={{ cursor: "pointer" }}
          />
        );
      },
    }),
  ];

  return (
    <div>
      {loading ? (
        <LoadingData searching={true} label="Buscando dados..." />
      ) : (
        <ToolkitTable
          keyField="IdPedido"
          dataTable={data}
          columnModel={columnModel}
          onRowClick={(_, row) => onRowClick(row)}
          headerTitle="Painel de Acompanhamento de Tickets de Atendimento"
          styledRow={{
            cursor: "pointer",
          }}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          csvFileName="acompanhamento_atendimento"
        />
      )}
    </div>
  );
}
